import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import useScrollStore from '../../../../common/store/useScrollStore';
import HandwriteCircle, { Wrapper as _HandwriteCircle } from '../../../../common/components/svg/HandwriteCircle';

const Wrapper = styled.a`
  margin: 40rem 0;

  display: flex;
  align-items: center;
  justify-content: start;

  cursor: pointer;
`;

const Numero = styled.p`
  position: relative;
  margin-right: 30rem;

  font-size: 25rem;

  ${_HandwriteCircle} {
    position: absolute;
    top: -50%;
    left: -110%;
    height: 60rem;
    width: auto;
  }
`;

const Text = styled.p`
  font-size: 35rem;
  line-height: normal;
`;

const Link = ({ number, label, to, active, setShow }: {
  number: string,
  label: string,
  to: number,
  active: boolean,
  setShow: (show: boolean) => void
}) => {
  const scrollTo = useScrollStore(useCallback(state => state.scrollTo, []));

  const handleClick = () => {
    const position = -to * window.innerHeight;

    setShow(false);
    scrollTo && scrollTo(position, false);
  }


  return (
    <Wrapper onClick={handleClick}>
      <Numero>
        <HandwriteCircle active={active} />
        {number}
      </Numero>

      <Text>{label}</Text>
    </Wrapper>
  );
}

export default Link;